import { get, put, post } from "@api/fetch"
import {
  GET_USER_ORGANIZATION,
  UPDATE_USER_ORGANIZATION,
  SAVE_USER_ORGANIZATION,
  INVITE_USERS
} from "@actions/organizations/"
import { addGlobalMessage } from "@api/utils/"

export const getUserOrganization = () => (dispatch, getState) =>
  dispatch(get(GET_USER_ORGANIZATION, `organizations/${getState().user.auth.organization_id}`))

export const updateUserOrganization = (key, value) => dispatch =>
  dispatch({ type: UPDATE_USER_ORGANIZATION, key, value })

export const saveUserOrganization = (key, value) => (dispatch, getState) => {
  dispatch(
    put(SAVE_USER_ORGANIZATION, `organizations/${getState().user.auth.organization_id}`, { key, value }, null)
  )
}

export const sendInvites = (users) => (dispatch, getState) => {
  dispatch(
    post(
      INVITE_USERS,
      `organizations/${getState().user.auth.organization_id}/users`,
      {
        users
      },
      () => dispatch(addGlobalMessage(`User${users.length === 1 ? '' : 's'} invited!`, "success"))
    )
  )
}
